import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => new QueryClient();
